/* ================================================================
   Local Stats — uses localStorage instead of Redis.
   All profile/stats/leaderboard data lives on the client.

   Redis-backed API calls are commented out but preserved.
   ================================================================ */

const getApiBase = (): string => {
  if (process.env.REACT_APP_SERVER_URL) return process.env.REACT_APP_SERVER_URL;
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:3001`;
};
const API_BASE = getApiBase();

const STATS_KEY = 'ace_player_stats';

export interface HealthStatus {
  status: string;
  // redis: boolean;  // No longer needed
}

export interface FullProfile {
  name: string;
  createdAt: number;
  updatedAt: number;
  gamesPlayed: number;
  gamesWon: number;
  gamesLost: number;
  totalCuts: number;
}

export interface LeaderboardEntry {
  playerId: string;
  name: string;
  wins: number;
}

export interface LiveKitTokenResponse {
  token: string;
  serverUrl: string;
  roomName: string;
}

const getStoredStats = (): FullProfile => {
  try {
    const raw = localStorage.getItem(STATS_KEY);
    if (raw) return JSON.parse(raw);
  } catch { /* corrupted data */ }
  return {
    name: '',
    createdAt: Date.now(),
    updatedAt: Date.now(),
    gamesPlayed: 0,
    gamesWon: 0,
    gamesLost: 0,
    totalCuts: 0,
  };
};

const saveStats = (stats: FullProfile): void => {
  localStorage.setItem(STATS_KEY, JSON.stringify(stats));
};

export const fetchProfile = async (playerId: string): Promise<FullProfile | null> => {
  void playerId;
  const stats = getStoredStats();
  const savedName = localStorage.getItem('ace_player_name') || 'Guest';
  return { ...stats, name: stats.name || savedName };
  // try {
  //   const res = await fetch(`${API_BASE}/api/profile/${playerId}`);
  //   if (!res.ok) return null;
  //   return res.json();
  // } catch {
  //   return null;
  // }
};

export const fetchLeaderboard = async (): Promise<LeaderboardEntry[]> => {
  return [];
  // try {
  //   const res = await fetch(`${API_BASE}/api/leaderboard`);
  //   if (!res.ok) return [];
  //   return res.json();
  // } catch {
  //   return [];
  // }
};

export const updateProfileName = async (_playerId: string, name: string): Promise<boolean> => {
  const stats = getStoredStats();
  stats.name = name;
  stats.updatedAt = Date.now();
  saveStats(stats);
  return true;
  // try {
  //   const res = await fetch(`${API_BASE}/api/profile/${playerId}/name`, {
  //     method: 'PUT',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ name }),
  //   });
  //   return res.ok;
  // } catch {
  //   return false;
  // }
};

export const fetchLiveKitToken = async (data: {
  roomCode: string;
  playerName: string;
  playerId: string;
}): Promise<LiveKitTokenResponse> => {
  const res = await fetch(`${API_BASE}/api/livekit/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  let payload: any = null;
  try {
    payload = await res.json();
  } catch {
    payload = null;
  }

  if (!res.ok) {
    throw new Error(payload?.message || 'Could not join voice chat');
  }

  return payload as LiveKitTokenResponse;
};

export const recordLocalGameResult = (result: {
  isLoser: boolean;
  isSafe: boolean;
  cutsReceived: number;
}): void => {
  const stats = getStoredStats();
  stats.gamesPlayed++;
  if (result.isLoser) stats.gamesLost++;
  else if (result.isSafe) stats.gamesWon++;
  stats.totalCuts += result.cutsReceived;
  stats.updatedAt = Date.now();
  saveStats(stats);
};
